import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';

import { ExtraTrainingFieldsDocument } from 'graphql/types';
import { extraFieldsToFormValues } from 'common/utils/extraFields';

export const useTrainingExtraFields = (extraFieldsValue?: string) => {
    const {
        data: extraFieldsData,
        error,
        loading,
    } = useQuery(ExtraTrainingFieldsDocument);

    const extraFields = useMemo(
        () => extraFieldsData?.extraTrainingFields || [],
        [extraFieldsData?.extraTrainingFields]
    );

    const extraFieldValues = useMemo(
        () =>
            extraFieldsToFormValues(
                extraFields,
                extraFieldsValue ? JSON.parse(extraFieldsValue) : undefined
            ),
        [extraFields, extraFieldsValue]
    );

    return { extraFields, extraFieldValues, loading, error };
};
